/**
 * About Banner 3
 */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

class AboutBanner3 extends Component {

    constructor(){
        super();
        this.state = { showText: false };
      }
 
   render() {
   
    return (
        <Row className="section-ptb" style={{padding:"5px"}}>
            <div className="col-sm-12">
                <Row className="d-flex align-items-center">
            
                <div className="ciyashop_banner_wrapper">
                    <div className="ciyashop_banner ciyashop_banner-style-style-1 ciyashop_banner-effect-none banner-1">
                            <img className="ciyashop_banner-image img-fluid inline" style={{width:"100%",height :"90vh",objectFit:"cover"}} alt="Banner" src={require(`../assets/images/houseOfSeroBanner.png`)} />
                    
                       
                    </div>
                </div>
                
              
                </Row>
            </div>
{/* 
                        <div className="ciyashop_banner ciyashop_banner-3 ciyashop_banner-style-style-1 ciyashop_banner-effect-none">
                            <img className="ciyashop_banner-image img-fluid inline" alt="Banner" src={require(`../assets/images/categories/default/adv-banner-img2.png`)} />
                            <div className="ciyashop_banner-content position-md-r ciyashop_banner-content-hleft ciyashop_banner-content-vtop">
                                <div className="ciyashop_banner-content-wrapper">
                                <div className="ciyashop_banner-content-inner-wrapper">
                                    <div className="ciyashop_banner-text-wrap ciyashop_banner-text-wrap-1 hidden-lg hidden-md hidden-sm hidden-xs">
                                    <div className="ciyashop_banner-text">
                                    <h2 className="mt-sm-0">Tops</h2>
                                    </div>
                                    </div>
                                    <div className="ciyashop_banner-text-wrap ciyashop_banner-text-wrap-2 hidden-lg hidden-md hidden-sm hidden-xs">
                                    <div className="ciyashop_banner-text">
                                    <h3>Season festival</h3>
                                    </div>
                                    </div>
                                    <div className="ciyashop_banner-btn-wrap ciyashop_banner-btn-style-flat ciyashop_banner-btn-size-md ciyashop_banner-btn-shape-square"> <Link to="/shop" className="ciyashop_banner-btn">Buy now!</Link></div>
                                </div>
                                </div>
                            </div>
                        </div> */}
                        
            </Row>
      )
   }
}

export default AboutBanner3;
